export const rugbyPitchConfig = {
  // bg-[rgba(22,107,21,1)] = bg-success-1 (shared color pallete not used yet in mobile )
  fieldUnderlaysClass: 'bg-[rgba(22,107,21,1)]',
  fieldClass: 'h-full aspect-[1.8]',
}
